import React, {PropTypes} from 'react';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import authActions from '../../auth/auth_actions';
import addTripsActions from '../add_trips_actions';
import './view_trips.less'
import DashBoardHeader from '../../header_dashboard/dashboard_header';
import InputComponent from '../../components/input_component/input_component';
import LocationInput from '../../components/location_auto_search/location_auto_search'
import LoggedinFooter from '../../footer/loggedin_footer';
import ShowError from '../../components/error/show_error';
import validate from '../../util/validate';
import {toTitleCase,join,localTimestampToGMT,GMTTimeStampToLocal} from '../../util/common';
import moment from 'moment';
import {Link, browserHistory} from 'react-router';
import CONSTANTS from '../../common_constants';
import ConfirmDeleteComponent from '../../components/confirm_box/confirm_box';

class TripDetailsComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let trip = this.props.trip;
    return (
      <div className = "trip-details-component-wrap">
        <div className = "details-wrap">
          <div className = "details">
            <div className = "title">
              From:
            </div>
            <div className = "content">
              {trip.destinationLocation}
            </div>
          </div>
          <div className = "details margin">
            <div className = "title">
              To:
            </div>
            <div className = "content">
              {trip.arrivalLocation}
            </div>
          </div>
        </div>
        <div className = "edit-wrap">
          <div className = "options" onClick ={() =>this.props.edit(trip.tripId)}>
            Edit
          </div>
          <div className = "options" onClick ={() =>this.props.delete(trip.tripId)}>
            Delete
          </div>
        </div>
      </div>
    )
  }
}

class ViewTrips extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count : 10,
      offset : 0,
      showConfirmBox : false,
      deleteTripDetails : "",
      showLoadMore : false
    }
  }
  getAllTrips = (paramObj) =>{
    this.setState({
      ajaxInProgress : true
    })
    this.props.addTripsActions.getAllTrips(paramObj).then((data) => {
      let showLoadMore = false
      if(this.props.addTrips.allTrips.length < data.totalCount)
      {
        showLoadMore = true;
      }
      this.setState({
        ajaxInProgress : false,
        showLoadMore
      })
    }, (errorRes) => {
        if(errorRes.error === CONSTANTS.sessionInvalid){
          this.setState({ajaxInProgress: false})
          this.props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        this.setState({ajaxInProgress: false,successMsg:""});
        this.setState({error: errorRes.error, validationError: validationError});
    })
  }
  componentDidMount(){
    this.props.addTripsActions.clearAllTrips();
    let paramObj = {
      count : this.state.count ,
      offset : this.state.offset
    }
    this.getAllTrips(paramObj)
  }
  getMoreTrip = () =>{
    let paramObj
    this.setState({
      offset : this.state.offset + this.state.count
    },() =>{
      paramObj = {
      count : this.state.count ,
      offset : this.state.offset
      }
      this.getAllTrips(paramObj)
    })
  }

  editTrip = (tripId) =>{
    browserHistory.push("add-trips?id="+tripId)
  }

  deleteTrip = () =>{
    this.setState({
      ajaxInProgress : true
    })
    let tripId = this.state.deleteTripDetails;
    const {userData} = this.props.authState;

    this.props.addTripsActions.deleteTrip(tripId).then((data) => {

      if(userData.email) amplitude.getInstance().setUserId(userData.email);
      amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.DELETE_TRIP);

      this.setState({
        ajaxInProgress : false
      })
    }, (errorRes) => {
        if(errorRes.error === CONSTANTS.sessionInvalid){
          this.setState({ajaxInProgress: false})
          this.props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        this.setState({ajaxInProgress: false,successMsg:""});
        this.setState({error: errorRes.error, validationError: validationError});
    })
  }
  confirmDelete = (tripId) =>{
    this.setState({
        deleteTripDetails : tripId,
        showConfirmBox : true
    })
  }
  hideConfirmBox = () =>{
    this.setState({
      showConfirmBox : false
    })
  }

  render() {
    let allTrips = this.props.addTrips.allTrips;
    const loader = <div className="loader"></div>;
    return (
      <div className = "view-trips-wrap">
        {this.state.ajaxInProgress && <div className = "loader-wrapper"><div className = "loader"></div></div>}
        {this.state.error && <ShowError errorMessage={this.state.error}/>}
        <ConfirmDeleteComponent onConfirmCallback = {this.deleteTrip} closePopupCallback = {this.hideConfirmBox}header = "Confirm" description = "Are you sure that you want to delete the trip?" popupState = {this.state.showConfirmBox}/>
        <Link to = "/add-trips"><div className = "add-trips">Add Trip</div></Link>
        <div className ="heading">
          My Trips
        </div>
          {
            allTrips.length > 0 && allTrips.map((trip,index) => {
              return(
                <TripDetailsComponent trip ={trip} key = {index} edit={this.editTrip} delete = {this.confirmDelete}/>
              )
            })
          }
          {
            allTrips.length == 0 &&
            <div className = "no-trips-section">
              <div className = "no-trips-content">
                No Trips added.
              </div>
            </div>
          }
          {
            this.state.showLoadMore &&
            <div className = "load-more">
                <button onClick = {this.getMoreTrip} className="btn green">Load more</button>
            </div>
          }
      </div>
    )
  }
}


ViewTrips = connect((state) => {
  return {
    addTrips : state.app.addTrips,
    authState: state.app.auth
  }
}, (dispatch) => {
  return {
    routerActions: bindActionCreators(routerActions, dispatch),
    authActions : bindActionCreators(authActions, dispatch),
    addTripsActions :bindActionCreators(addTripsActions, dispatch)
  }
})(ViewTrips);

export default ViewTrips;



// WEBPACK FOOTER //
// app/add_trips/view_trips/view_trips.jsx